import { useNavigate } from 'react-router-dom';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ChargePointPopup from "@/pages/comp/basic/point/popup/charge_point_popup";

function ToTalArea(props: any) {
  let myProps = {
    Style: {},
    chat: {},
    ...props
  };
  let Style = myProps.Style;
  let chat = myProps.chat;
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [mcomp_point, set_mcomp_point] = useState<any>(0);

  const default_popup_data = {
    isOpen: false,
    sort: "charge_point",
    title: "팝업",
    width: "500px",
    height: "80%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  useEffect(() => {
    getPointNumByAjax();
  }, [user]);

  const getPointNumByAjax = () => {
    if (user.comp_seq) {

    } else {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  const open_charge_point_popup = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    let pop_title = "포인트 충전";

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "charge_point",
      title: pop_title,
      width: "500px",
      height: "90%",
    });
  };

  let tot_div_wrap_style: any = {
    borderTop: "1px solid #eee", borderBottom: "1px solid #eee", position: "relative",
    textAlign: "left",
    marginTop:"30px"
  };

  return (
    <div className="con_wrap" style={tot_div_wrap_style}>
      <div className={Style.total_cnt_box} style={{ marginLeft: 0 }}>
        <span className={Style.total_cnt_box_title} >플랜톡</span>
        <span className={Style.total_cnt_box_num}>{chat.unreadToT}</span>
      </div>
      <div className={Style.total_cnt_box}>
        <span className={Style.total_cnt_box_title} >어제학습현황</span>
        <span className={Style.total_cnt_box_num}>0%</span>
      </div>
      <div className={Style.total_cnt_box}>
        <span className={Style.total_cnt_box_title} >포인트</span>
        <span className={Style.total_cnt_box_num}>
          {strFunc.comma(mcomp_point)}
          <button className='btn btn-dark ml-2'
            onClick={() => {
              open_charge_point_popup({});
            }}
          >포인트 충전</button>
        </span>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "charge_point" &&
            <ChargePointPopup
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => {
                getPointNumByAjax();
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></ChargePointPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default ToTalArea;